import useWidth from '../../components/Hooks/useWidth';
import { ListTemplate } from '../../components/ListTemplate';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../../modules/translation/TranslationContext';
import PATHS from '../../routes/routes.const';
import { GeneralSettingsParams } from '../../stores/GeneralSettings/generalSettings.types';
import { BRASILIA_TIMEZONE } from '../../utils/timezones';
import { SortBy } from '../orders/export/V2/ExportOrderModal.types';
import { ExportModel } from '../orders/export/V2/ExportOrderModal.types';
import { PageOrientation } from '../orders/export/V2/ExportOrderModal.types';
import { OrderHeadersGroupByEnum } from '../orders/products/orderProducts.types';
import { ReportPeriodFilterEnum } from '../reports/reports-page/Enum/ReportPeriodFilterEnum';
import GeneralSettingsForm from './GeneralSettingsForm';
import { DEFAULT_SELLOUT_REFERENCE_PERIOD_IN_DAYS } from './consts/sellout.consts';
import { GridSizeEnum } from './enums/gridSize.enum';
import { MediaFormatEnum } from './enums/mediaFormat.enum';
import { MediaZoomTypeEnum } from './enums/mediaZoomType.enum';
import { OrderBookBadgeValueType } from './enums/orderBadgeDisplayType.enum';
import OrderContractSignatureRequired from './enums/orderContractSignatureRequired.enum';
import { ReferencePeriodEnum } from './enums/referencePeriod.enum';

export const generalSettingsDefault: GeneralSettingsParams = {
  forceCopyOrderWithConditions: false,
  minimumOrderValue: null,
  minimumPreOrderValue: null,
  enablePublicShowroom: false,
  minimumReadyForDeliveryValue: null,
  dropboxConfigId: undefined,
  dropboxDefaultFolder: undefined,
  dropboxErrorCode: null,
  enablePriceTableByRepresentative: false,
  enableChangeOrderSalesRep: false,
  autoAcceptInviteFromCustomerWithRepresentative: false,
  allowRepresentativesToInviteCustomers: false,
  enableMarkup: false,
  enableRetailPrice: false,
  customerSupportPhone: null,
  maxStockToShow: null,
  abandonedOrderTimeout: null,
  abandonedOrderPreOrderTimeout: null,
  abandonedOrderFutureStockTimeout: null,
  suggestedClassificationType: null,
  enableRelatedProductsFilterInProductDetails: false,
  orderCollection: null,
  preOrderCollection: null,
  readyForDeliveryCollection: null,
  abandonOrderByDate: 'created_at',
  abandonOrderByFutureStockDate: 'created_at',
  abandonOrderByPreOrderDate: 'created_at',
  reportPeriodFilter: ReportPeriodFilterEnum.ORDER_CREATE_DATE,
  fileCodesSeparator: '_',
  showProductsWithZeroWholesalePrice: false,
  timezone: BRASILIA_TIMEZONE,
  enableSaleType: false,
  bypassOrderOnApprovalOnReadyForDelivery: false,
  allowBlockedCustomerToCreateOrder: false,
  allowApproveOrderForBlockedCustomer: false,
  orderContractSignatureRequired: OrderContractSignatureRequired.BY_NONE,
  mediaFormat: MediaFormatEnum.RECTANGULAR,
  mediaZoomType: MediaZoomTypeEnum.IMMEDIATE_ZOOM,
  gridSize: GridSizeEnum.NORMAL,
  rolesToHideStock: null,
  rolesToHideOrderObservation: null,
  selloutPeriodLastDaysInterval: DEFAULT_SELLOUT_REFERENCE_PERIOD_IN_DAYS,
  selloutReferencePeriod: ReferencePeriodEnum.LAST_DAYS,
  productInputLockValue: 9,
  restrictProductsUsingCatalogs: false,
  restrictProductsUsingCustomerCatalogs: false,
  showOrderConditionShippingCost: false,
  blockOrderWithoutCustomer: false,
  showPaymentMethodsAccumulatedInterest: false,
  orderBookBadgeValueType: OrderBookBadgeValueType.ORDER_PRODUCTS,
  requirePaymentReleaseForImmediate: false,
  requirePaymentReleaseForPreOrder: false,
  billingForecastRuleForPreOrder: null,
  billingForecastRuleForReadyForDelivery: null,
  contractPageOrientation: PageOrientation.PORTRAIT,
  contractExportModel: ExportModel.STANDARD,
  contractGroupBy: OrderHeadersGroupByEnum.DEFAULT,
  contractSortBy: SortBy.LAST_ADDED,
  contractShowSellInPrice: true,
  contractShowPriceComposition: false,
  contractShowSizePriceVariation: false,
  contractShowMarkupAndSellout: false,
  contractCreateSummary: false,
  autoContractGeneration: null,
  enableRepVisibilityBetweenReps: false,
  showSellInPriceFilterInCatalogs: false,
  showSiblingColorMedia: false,
};

const GeneralSettingsPage = () => {
  const { mobileWidth } = useWidth();
  const { translate } = useTranslation();

  return (
    <ListTemplate
      title={translate(LangEnum.GLOBAL_GENERAL_DEFINITIONS)}
      renderTable={() => <GeneralSettingsForm />}
      goBackUrl={mobileWidth ? PATHS.main.settings.path : undefined}
    />
  );
};

export default GeneralSettingsPage;
